/* eslint-disable @typescript-eslint/naming-convention */
import { Flex, Text } from '@servicetitan/anvil2';
import document from '../../common/illustrations/unable-to-load.svg';
import { ProviderDisclosures } from '@servicetitan/financing-provider-assets';

export const ConsentNotReceived = () => {
    return (
        <Flex
            direction="column"
            alignSelf="center"
            alignItems="center"
            gap="8"
            style={{ maxWidth: '845px', margin: '0 auto' }}
        >
            <img src={document} />
            <Text variant="headline" el="h3">
                E-sign consent not received
            </Text>
            <Text
                dangerouslySetInnerHTML={{ __html: ProviderDisclosures.serviceFinance.notReceived }}
            />
        </Flex>
    );
};
